var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"404"}},[_c('PageTop',{attrs:{"title":"お問い合わせ完了","en":"THANKS"}}),_vm._m(0),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"sub-page",attrs:{"id":"404-sec1"}},[_c('p',[_vm._v(" お問い合わせいただきありがとうございます。"),_c('br'),_vm._v(" 内容を確認した後、担当者よりご連絡いたします。 ")]),_c('a',{attrs:{"href":"/"}},[_vm._v(" TOPに戻る ")])])
}]

export { render, staticRenderFns }